var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm.startPayload}},[_c('h1',{staticClass:"color-text"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"color-text"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }